/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc ios微信登录专用
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  iOSWechatDto: oauth2.IOSWechatDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: oauth2.OAuth2AccessTokenDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oauth2/ios/wechat/oauth`,
    data: iOSWechatDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
